import React, { useRef } from "react";
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
} from "react-google-maps";
import { useDispatch, useSelector } from "react-redux";
import Type from "../../Redux/Type";
import { getPolygonByDistance2 } from "../../Containers/MapView";
import setup from "../../Containers/setup";
import { removeMask } from "../../Containers/MainController";
import TNH_SETUP from "../../Containers/setup";
import { useState } from "react";


const MapView = withScriptjs(withGoogleMap(props => {
    const refMap = useRef();
    const dispatch = useDispatch();
    const {
        pickMapOn
    } = useSelector(state => state.searchState);
    const {
        showThuaDat
    } = useSelector(state => state.hienTrang);

    const [isRend, setRender] = useState(false);

    const [zoomLevel, setZoom] = useState(TNH_SETUP.defaultZoom);

    const ChageZoom = (zoomLV) => {
        setZoom(zoomLV)
    }


    const CallMask = () => {
        if (isRend === false) {
            removeMask()
            setRender(true)
        }
    }

    const onTilesLoaded = () => {

        if (!!refMap) {
            dispatch({ type: Type.REF_MAP_VIEW, value: refMap.current })

            CallMask()

            // if (showThuaDat === true) {
            let centerPoint = {
                lat: refMap.current.getCenter().lat(),
                lng: refMap.current.getCenter().lng(),
            },
                topRightPoint = {
                    latitude: refMap.current.getBounds().getNorthEast().lat(),
                    longitude: refMap.current.getBounds().getNorthEast().lng()
                },
                bottomLeftPoint = {
                    latitude: refMap.current.getBounds().getSouthWest().lat(),
                    longitude: refMap.current.getBounds().getSouthWest().lng()
                },
                zoom = refMap.current.getZoom();

            getPolygonByDistance2({ topRightPoint, bottomLeftPoint, centerPoint, zoom });
            //}
        }
    };


    return (
        <div id="content-google">
            <GoogleMap
                ref={refMap}
                defaultZoom={setup.defaultZoom}
                defaultCenter={props.defaultCenter}
                onDragEnd={() => { removeMask() }}
                options={{
                    styles: [{ featureType: 'poi', stylers: [{ visibility: 'off' }] }],
                    mapTypeControl: false,
                    streetViewControl: false,
                    zoomControl: props.zoomControl,
                    draggableCursor: pickMapOn && `crosshair `,
                    maxZoom: zoomLevel
                }}
                onTilesLoaded={onTilesLoaded}
                defaultMapTypeId={'satellite'}
                mapTypeId={props.mapTypeId}
                onClick={ev => props.onClick(ev)}
            >

                {props.children}
            </GoogleMap>
        </div>
    )
}
));


export default MapView;
